// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Shell layout ────────────────────────────────────────────────────────── */
.ecr-ops-shell {
  display: flex;
  min-height: 100vh;
  background: #f4f5f7;
  font-family: "Open Sans", "Segoe UI", sans-serif;
}

/* ── Sidebar ─────────────────────────────────────────────────────────────── */
.ecr-ops-sidebar {
  width: 230px;
  min-height: 100vh;
  background: #1a1a1a;
  display: flex;
  flex-direction: column;
  transition: width 0.22s ease;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}

.ecr-ops-sidebar.collapsed {
  width: 60px;
}

/* Header */
.ecr-ops-sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 14px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  min-height: 64px;
}

.ecr-ops-sidebar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  overflow: hidden;
  background: none;
  border: none;
  padding: 0;
  text-align: left;
}

.ecr-ops-sidebar__brand-badge {
  background: #86BC25;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  padding: 3px 7px;
  border-radius: 4px;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.ecr-ops-sidebar__brand-label {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: 0.2px;
}

.ecr-ops-sidebar__toggle {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.15s, background 0.15s;
}

.ecr-ops-sidebar__toggle:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

/* Nav */
.ecr-ops-sidebar__nav {
  flex: 1 1;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
}

.ecr-ops-sidebar__link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #9ca3af;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
  overflow: hidden;
}

.ecr-ops-sidebar__link:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #e5e7eb;
}

.ecr-ops-sidebar__link.active {
  background: rgba(0, 166, 81, 0.18);
  color: #a0d645;
}

.ecr-ops-sidebar__link-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 20px;
}

.ecr-ops-sidebar__link-icon svg {
  font-size: 20px;
}

.ecr-ops-sidebar__link-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Footer */
.ecr-ops-sidebar__footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 11px;
  color: #4b5563;
  text-align: center;
}

/* ── Main content ────────────────────────────────────────────────────────── */
.ecr-ops-main {
  flex: 1 1;
  overflow-y: auto;
  min-width: 0;
}

/* One consistent strip above every ecr-ops page's own content — some pages
   (Enterprise Usage, Stuck Users detail) don't render .ecr-ops-page-header,
   so this lives in the layout itself rather than overlaying into that banner. */
.ecr-ops-platform-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 36px;
  background: #1a1a1a;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.ecr-ops-platform-bar .MuiTypography-root {
  color: #d1d5db;
}

.ecr-ops-platform-bar .MuiSelect-select {
  color: #fff;
}

.ecr-ops-platform-bar .MuiOutlinedInput-notchedOutline {
  border-color: rgba(255, 255, 255, 0.25);
}

.ecr-ops-platform-bar .MuiSvgIcon-root {
  color: #d1d5db;
}

/* ── Shared page header ──────────────────────────────────────────────────── */
.ecr-ops-page-header {
  background: #1a1a1a;
  color: #fff;
  padding: 28px 36px 24px;
  border-bottom: 3px solid #86BC25;
}

.ecr-ops-page-header__eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #86BC25;
  margin-bottom: 4px;
}

.ecr-ops-page-header__title {
  font-size: 24px;
  font-weight: 800;
  margin: 0 0 4px;
  color: #fff;
}

.ecr-ops-page-header__sub {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
}

/* ── Shared content area ─────────────────────────────────────────────────── */
.ecr-ops-content {
  padding: 14px 36px;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsLayout.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,+EAA+E;AAC/E;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;;gFAEgF;AAChF;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB","sourcesContent":["/* ── Shell layout ────────────────────────────────────────────────────────── */\n.ecr-ops-shell {\n  display: flex;\n  min-height: 100vh;\n  background: #f4f5f7;\n  font-family: \"Open Sans\", \"Segoe UI\", sans-serif;\n}\n\n/* ── Sidebar ─────────────────────────────────────────────────────────────── */\n.ecr-ops-sidebar {\n  width: 230px;\n  min-height: 100vh;\n  background: #1a1a1a;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.22s ease;\n  flex-shrink: 0;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.ecr-ops-sidebar.collapsed {\n  width: 60px;\n}\n\n/* Header */\n.ecr-ops-sidebar__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 14px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  min-height: 64px;\n}\n\n.ecr-ops-sidebar__brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  overflow: hidden;\n  background: none;\n  border: none;\n  padding: 0;\n  text-align: left;\n}\n\n.ecr-ops-sidebar__brand-badge {\n  background: #86BC25;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  padding: 3px 7px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n\n.ecr-ops-sidebar__brand-label {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n  letter-spacing: 0.2px;\n}\n\n.ecr-ops-sidebar__toggle {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: color 0.15s, background 0.15s;\n}\n\n.ecr-ops-sidebar__toggle:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* Nav */\n.ecr-ops-sidebar__nav {\n  flex: 1;\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow-y: auto;\n}\n\n.ecr-ops-sidebar__link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  color: #9ca3af;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background 0.15s, color 0.15s;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.ecr-ops-sidebar__link:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: #e5e7eb;\n}\n\n.ecr-ops-sidebar__link.active {\n  background: rgba(0, 166, 81, 0.18);\n  color: #a0d645;\n}\n\n.ecr-ops-sidebar__link-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  font-size: 20px;\n}\n\n.ecr-ops-sidebar__link-icon svg {\n  font-size: 20px;\n}\n\n.ecr-ops-sidebar__link-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Footer */\n.ecr-ops-sidebar__footer {\n  padding: 14px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 11px;\n  color: #4b5563;\n  text-align: center;\n}\n\n/* ── Main content ────────────────────────────────────────────────────────── */\n.ecr-ops-main {\n  flex: 1;\n  overflow-y: auto;\n  min-width: 0;\n}\n\n/* One consistent strip above every ecr-ops page's own content — some pages\n   (Enterprise Usage, Stuck Users detail) don't render .ecr-ops-page-header,\n   so this lives in the layout itself rather than overlaying into that banner. */\n.ecr-ops-platform-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 10px 36px;\n  background: #1a1a1a;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.ecr-ops-platform-bar .MuiTypography-root {\n  color: #d1d5db;\n}\n\n.ecr-ops-platform-bar .MuiSelect-select {\n  color: #fff;\n}\n\n.ecr-ops-platform-bar .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.ecr-ops-platform-bar .MuiSvgIcon-root {\n  color: #d1d5db;\n}\n\n/* ── Shared page header ──────────────────────────────────────────────────── */\n.ecr-ops-page-header {\n  background: #1a1a1a;\n  color: #fff;\n  padding: 28px 36px 24px;\n  border-bottom: 3px solid #86BC25;\n}\n\n.ecr-ops-page-header__eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: #86BC25;\n  margin-bottom: 4px;\n}\n\n.ecr-ops-page-header__title {\n  font-size: 24px;\n  font-weight: 800;\n  margin: 0 0 4px;\n  color: #fff;\n}\n\n.ecr-ops-page-header__sub {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n/* ── Shared content area ─────────────────────────────────────────────────── */\n.ecr-ops-content {\n  padding: 14px 36px;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
